import React from "react";
import { Box, Card } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import clsx from "clsx";
import ClientExercises from "./ClientExercises";
import ClientWorkouts from "./ClientWorkouts";

const useStyles = makeStyles((theme) => ({
  root: {
    padding: 0,
    background: "transparent",
    boxShadow: "none",
    border: "none",
    overflow: "visible",
  },
  mainContainer: {
    display: "flex",
    gap: theme.spacing(3),
    [theme.breakpoints.down("md")]: {
      flexDirection: "column",
    },
  },
}));

const ClientWorkoutsExercises = ({
  clientId,
  username,
  createdAt,
}: {
  clientId: number;
  username?: string;
  createdAt?: string;
}) => {
  const s = useStyles();

  return (
    <Card className={clsx(s.root)}>
      <Box className={s.mainContainer}>
        <ClientWorkouts clientId={clientId} username={username} />
        <ClientExercises
          clientId={clientId}
          username={username}
          createdAt={createdAt}
        />
      </Box>
    </Card>
  );
};

export default React.memo(ClientWorkoutsExercises);
